import { render, staticRenderFns } from "./ModattaSideModalNewOfferAudienceByRecommendation.vue?vue&type=template&id=43020f5c"
import script from "./ModattaSideModalNewOfferAudienceByRecommendation.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalNewOfferAudienceByRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports